import { buildProps, iconPropType } from '@jdesign-vue/utils'
import { radioPropsBase } from './radio'
import type { ExtractPropTypes } from 'vue'
import type RadioCard from './radio-card.vue'

export const radioCardProps = buildProps({
  ...radioPropsBase,
  /**
   * @description native 'name' attribute
   */
  name: {
    type: String,
    default: '',
  },
  desc: {
    type: String,
  },
   /**
   * @description desc of Switch
  */
   showDesc: {
    type: Boolean,
    default: true,
  },
  /**
   * @description icon component
  */
  icon: {
    type: iconPropType,
  },
  /**
   * @description icon size
  */
  iconSize: {
    type: Number,
    default: 44,
  },
  /**
   * @description icon color
  */
  iconColor: {
    type: String,
  },
  showRadio: {
    type: Boolean,
    default: true,
  },
} as const)

export type RadioCardProps = ExtractPropTypes<typeof radioCardProps>
export type RadioCardInstance = InstanceType<typeof RadioCard>
